/**
 * Enum representing different outbox item statuses.
 */
export enum OutboxStatusEnum {
	/**
	 * Represents an outbox item that is pending delivery.
	 */
	PENDING = 'pending',

	/**
	 * Represents an outbox item that has been leased for synchronization.
	 */
	LEASED = 'leased',

	/**
	 * Represents an outbox item that has been superseded.
	 */
	SUPERSEDED = 'superseded',

	/**
	 * Represents an outbox item that has been successfully sent.
	 */
	SENT = 'sent',

	/**
	 * Represents an outbox item that has failed to be sent during the latest delivery attempt.
	 */
	FAILED = 'failed',

	/**
	 * Represents an outbox item that has failed all delivery attempts.
	 */
	DEAD_LETTERED = 'dead_lettered',
}
